<template>
    <div class="profile">
        <div class="profile_user">
            <div class="profile_user_desc">
                <img :src="auth.image" :alt="auth.name" :title="auth.name">
                <span>{{ auth.name }}</span>
            </div>

            <div class="profile_user_actions">
                <div class="profile_user_actions_item profile_user_actions_itemExit" @click="logOut">
                    <Icon name="exit" />
                    <span>Sair</span>   
                </div>
            </div>
        </div>

        <div class="profile_menu">
            <Menus>
                <Menu
                    @click.native="changeProfile(false)"
                    name="Configurações da Conta"
                    icon="cog"
                    :router="{name: 'ProfileUser'}" />      
            </Menus>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { loadingFull } from 'sysweb-vue-components/src/global';

import Icon from '@Component/IconComponent';
import Menus from '../menus/MenusComponent';
import Menu from '../menus/MenuComponent';

const store = useStore();
const router = useRouter();

const auth = computed(() => store.state.auth);

const changeProfile = (value) => {
    store.commit('changeProfile', value);
};

const logOut = () => {
    try {
        store.commit('auth/logOut');
        
        changeProfile(false);
        
        loadingFull({
            enabled: true,
            text: 'Saindo do dashboard administrativo'
        });

        setTimeout(() => {                    
            loadingFull({ enabled: false });
            
            router.push({ name: 'Login' });
        }, 2000);
    } catch (error) {
        console.log(error);
    }
};
</script>

<style lang="scss" scoped>
    .profile{
        position: fixed;
        top: 0px;
        right: 0px;
        background: #ffffff;
        width: 400px;
        height: 100%;
        padding: 50px;
        z-index: 102;
    }

    .profile_user{
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 1px solid var(--borderColorDefault);
        padding-bottom: 20px;
        margin-bottom: 20px; 
    }
    .profile_user_desc{
        display: flex;
        flex-direction: column;
        align-items: center;

        img{
            width: 50px;
            border-radius: 50%;
        }
    }
    .profile_user_actions{
        text-transform: uppercase;
        font-size: 14px;

        
    }
    .profile_user_actions_item{
        margin-bottom: 8px;
        cursor: pointer;

        & .icon{
            font-size: 16px;
            margin-right: 5px;
            vertical-align: middle;
        }

        & span{
            font-size: 12px;
        }

        &:last-child{
            margin-bottom: 0px;
        }
    }
    .profile_user_actions_itemExit{
        color: #ae4343;
    }
</style>